import { createClient } from '@supabase/supabase-js';
import { projectId, publicAnonKey } from '../utils/supabase/info';

/**
 * Single Supabase client for the whole app.
 * Important: Keep a single instance so auth session is consistent across modules.
 */
export const supabase = createClient(`https://${projectId}.supabase.co`, publicAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

